<template lang="pug">
<div :class="(disabled) ? 'disabled' : ''">
    .bloco-situacao-territorio.bloco-alerta(v-if='valor > 0')
        .bloco-situacao-territorio__interno
            span.bloco-situacao-territorio-interno__texto1 {{ titulo }}
        .bloco-situacao-territorio__interno-divisoria
            span.bloco-situacao-territorio__interno__texto2 {{ subTitulo }}
            span.bloco-situacao-territorio__interno__numero {{ valor }}
            .bloco-situacao-territorio__interno__icone
                span
                    i.el-icon-arrow-right
    .bloco-situacao-territorio(v-else)
        .bloco-situacao-territorio__interno
            span.bloco-situacao-territorio-interno__texto1 {{ titulo }}
        .bloco-situacao-territorio__interno-divisoria
            span.bloco-situacao-territorio__interno__texto2 {{ subTitulo }}
            span.bloco-situacao-territorio__interno__numero {{ valor }}
            .bloco-situacao-territorio__interno__icone
                span
                    i.el-icon-arrow-right
</div>
</template>

<script>
export default {
    name: 'BlocoSituacaoTerritorio',
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        subTitulo: {
            type: String,
            default: () => ''
        },
        valor: {
            type: Number,
            default: () => 0
        },
        seta: {
            type: String,
            default: () => ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.disabled {
    opacity: 0.6 !important;
}
.disabled * {
    cursor: not-allowed !important;
}
.bloco-situacao-territorio {
    background: var(--white);
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    min-height: 89px;
    align-items: center;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 2px 0px var(--block-shadow);
    border-radius: 5px;
    cursor: pointer;
    border: 1px solid var(--default-border-color);

    .bloco-situacao-territorio__interno {
        margin-right: 3px;
        padding-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;

        .lyra-icon::before {
            content: '';
            width: 28px !important;
            height: 25px !important;
            background-color: var(--primary) !important;
        }
        .mdi::before {
            font-size: 26px !important;
            color: var(--primary) !important;
        }
    }
    .bloco-situacao-territorio__interno__texto2 {
        flex-wrap: wrap;
        font-size: 12px;
        font-weight: 500;
    }
    .bloco-situacao-territorio__interno__numero {
        font-size: 14px;
        font-weight: 600;
    }
    .bloco-situacao-territorio__interno__icone {
        margin-left: 10px;
        background: #f3f3f3;
        min-height: 89px;
        display: flex;
        align-items: center;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        color: var(--white);
        .el-icon-arrow-right:before {
            color: var(--primary) !important;
        }
    }
    span {
        padding: 3px;
        &.bloco-situacao-territorio-interno__texto1 {
            font-weight: 600;
            max-width: 88px;
        }
    }

    &:hover {
        border-color: var(--primary);
        .bloco-situacao-territorio__interno__icone {
            background-color: var(--primary);
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;

            .el-icon-arrow-right:before {
                color: var(--white) !important;
            }
        }
    }
    .bloco-situacao-territorio__interno-divisoria {
        display: flex;
        align-items: center;
    }
}
.bloco-alerta {
    border-color: var(--warning);
    &:hover {
        border-color: var(--warning);
        .bloco-situacao-territorio__interno__icone {
            background-color: var(--warning);
        }
    }
    .bloco-situacao-territorio-interno__texto1 {
        color: var(--warning);
    }
    .bloco-situacao-territorio__interno__icone {
        background-color: var(--warning);
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        &:hover {
            background: var(--warning) !important;
        }
        .el-icon-arrow-right:before {
            color: var(--white) !important;
        }
    }
}
@media only screen and (max-width: 1300px) {
    .bloco-situacao-territorio {
        min-width: 48% !important;
    }
}
</style>
